module.exports = __webpack_public_path__ + "507dfb68b9e5e7ba003ef85e5d30b6fd.svg";